import { useState } from "react"

import { Container, Box, Center, Flex, Text } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import Dropdown from "components/UI/atoms/Dropdown"
import Button from "components/UI/atoms/Button"
import HolidaysModal from "../modals/HolidaysModal"
import HolidaysModalForQappAdmin from "../modals/HolidaysModalForQappAdmin"

import useAuth from "hooks/useAuth"
import { useUI } from "providers/UIProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

const CompanyProfile: React.FC = () => {
  const { handleLogoutClick } = useAuth()
  const { isAdmin, userRole, userName, laundry } = useAppContext()
  const { toggleModal, T } = useUI()
  const [dropdownOpened, toggleDropdown] = useState<boolean>(false)

  const title = userName || laundry?.name || "";

  const dropdownItems: any = [
    {
      label: "",
      value: "logout",
      customComponent: (
        <Center padding="10px">
          <Button
            text={T("general.logout")}
            onClick={handleLogoutClick}
            variant="solid_gray"
            styles={{
              width: "100px",
              height: "30px",
              fontSize: "base",
            }}
          />
        </Center>
      ),
    },
  ]

  if(userRole !== IRoles.WASHER_MANAGER) {
    dropdownItems.unshift(
      {
        label: T("general.holiday"),
        value: "holiday",
        customHandler: () => isAdmin ? toggleModal("holidaysModalForQappAdmin", true)  : toggleModal("holidaysModal", true)
      },
    )
  }

  return (
    <Container margin={0} padding={0} pos="relative" zIndex={2} width="160px">
      <Box
        pointerEvents={`${dropdownOpened ? "none" : "auto"}`}
        onClick={() => toggleDropdown(true)}
        width="160px"
        height="40px"
        as="button"
        bg="white"
        boxShadow="primary"
        padding="0 10px"
        borderTopRadius="20px"
        borderBottomRadius={`${dropdownOpened ? "0" : "20px"}`}
        fontSize="base"
        cursor="pointer"
      >
        <Flex alignItems="center">
          <Center w="31px" h="31px" borderRadius="50%" bg="primary">
            <Icon name="user" />
          </Center>
          <Text ml="20px">{title}</Text>
        </Flex>
      </Box>
      <Dropdown
        selectable={false}
        opened={dropdownOpened}
        toggleOpened={toggleDropdown}
        items={dropdownItems}
      />
      {userRole !== IRoles.WASHER_MANAGER && (isAdmin ? <HolidaysModalForQappAdmin /> : <HolidaysModal />)}
    </Container>
  )
}

export default CompanyProfile
